import { HighlightedText } from 'src/shared/utils/text-highlighter/TextHighlighter'
import styles from 'src/styles/common.module.scss'

export const TextContentEs = () => {
    return (
        <HighlightedText
            text="Has ganado 400 giros gratis"
            highlights={[{ word: '400' }]}
            breakBeforeWords={['giros']}
            className={styles.text_content}
        />
    )
}
